import React from 'react';
import {
  SuccessIconContainer,
  SuccessIconCircleLineLeft,
  SuccessIconLineTip,
  SuccessIconLineLong,
  SuccessIconRing,
  SuccessIconFix,
  SuccessIconCircleLineRight,
} from './styled';

const AnimatedSuccessIcon = () => (
  <SuccessIconContainer>
    <SuccessIconCircleLineLeft />
    <SuccessIconLineTip />
    <SuccessIconLineLong />
    <SuccessIconRing />
    <SuccessIconFix />
    <SuccessIconCircleLineRight />
  </SuccessIconContainer>
);

export default AnimatedSuccessIcon;